import { render, staticRenderFns } from "./global-technical-details.vue?vue&type=template&id=e6153a36&scoped=true&"
import script from "./global-technical-details.vue?vue&type=script&lang=js&"
export * from "./global-technical-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6153a36",
  null
  
)

export default component.exports